import React from 'react';
import { equals } from "ramda";
import styled from "styled-components";
import { formatInferredValue, isEmptyDeep } from "../../../shared";
import { useState, useEffect } from "react";
import { useFluidForm, useFormInstance } from "./FormContext";
import { getFormInstance, useFormInstanceListener, useFormListener, useFormUpdatedListener } from "./FormInstance.service";
import scrollIntoView from 'scroll-into-view-if-needed';
import _ from 'lodash';
export const SectionTitleT = styled.div.attrs({
    className: 'fluid-section-title-t'
}) `
  font-size: ${props => ({ 1: "1.2rem", 2: "1.0rem", 3: "0.9rem", 4: "0.8rem" })[props.titleLevel || 1]};
  margin-top: 1rem;
  margin-bottom: 0.5rem;
    font-weight: bold;
`;
export function SectionTitle({ titleLevel, children }) {
    switch (titleLevel) {
        case 2:
            return React.createElement("h3", { className: `fluid-section-title  level-${titleLevel}` }, children);
            break;
        case 3:
            return React.createElement("h4", { className: `fluid-section-title  level-${titleLevel}` }, children);
            break;
        case 4:
            return React.createElement("h5", { className: `fluid-section-title  level-${titleLevel}` }, children);
            break;
    }
    return React.createElement("h2", { className: `fluid-section-title  level-${titleLevel}` }, children);
}
function moveCursorToEnd(el) {
    el.focus();
}
export function goToNext(fieldName, configService) {
    if (fieldName) {
        let next = configService.nextField(fieldName);
        if (next) {
            let nextElement = document.querySelector(`[data-fieldName="${next}"]`);
            //If nextElement is input
            if (nextElement instanceof HTMLInputElement) {
                moveCursorToEnd(nextElement);
            }
            else if (nextElement) {
                //Else select for input inside
                let input = nextElement.querySelector("input");
                if (!input) {
                    console.error("No input found a valid input element to go next", nextElement);
                }
                if (input) {
                    moveCursorToEnd(input);
                }
            }
        }
    }
}
export function goPrevious(fieldName, configService) {
    if (fieldName) {
        let prev = configService.getPreviousField(fieldName);
        if (prev) {
            let nextElement = document.querySelector(`[data-fieldName="${prev}"]`);
            if (nextElement) {
                moveCursorToEnd(nextElement);
            }
        }
    }
}
export function useRenderViewChange(fieldPath) {
    // const configService = useFluidForm();
    const [value, setValue] = useState(0);
    const instanceId = useFormInstance();
    useFormInstanceListener(instanceId, (event) => {
        if (event.type == "onFormUpdated") {
            setValue((v) => v + 1);
        }
    });
    return value;
}
export function useFormValue(fieldPath) {
    const instanceId = useFormInstance();
    const [value, setValue] = useState(getFormInstance(instanceId).getFluidForm()?.getValue(fieldPath));
    useFormUpdatedListener(instanceId, (event) => {
        setValue(getFormInstance(instanceId).getFluidForm()?.getValue(fieldPath));
    });
    const setFieldValue = (value) => {
        getFormInstance(instanceId).getFluidForm()?.setValue(fieldPath, value);
    };
    return [value, setFieldValue];
}
let lastSubmission = {};
const debounceValidateFields = _.debounce(async (instanceId) => {
    const client = getFormInstance(instanceId).client;
    const form = getFormInstance(instanceId).getFluidForm();
    let changedFields = form?.getChangedFields(lastSubmission);
    //Exclude current focused field
    changedFields = changedFields.filter(field => field !== form?.currentField);
    const subForm = form?.buildSubForm(changedFields);
    console.log("Current field is", form?.currentField);
    console.log("Changed fields", changedFields);
    if (changedFields.length > 0 && !subForm?.isEmpty()) {
        // @TODO: FLU-193 Handle this.
        let result = await client.updateField(form?.getFormKey(), getFormInstance(instanceId).submissionId || "", subForm?.getFormSubmissionFlat() || {});
        form?.mergeSubmissionData(result.inferredData || {}, true);
        getFormInstance(instanceId).dispatch("mergeValidationResults", result);
        lastSubmission = form?.getFormSubmission();
        console.log("lastSubmission is", lastSubmission);
    }
}, 1100, { leading: false, trailing: true });
export function useInlineValidation() {
    useFormListener("onBlur", (event, { form, instanceId }) => {
        debounceValidateFields(instanceId);
    });
    useFormListener("onSelect", (event, { form, instanceId }) => {
        debounceValidateFields(instanceId);
    });
}
export function useUpdateChatOnFieldChange(useUpdateChat = true) {
    useFormListener("onBlur", (event, { form, instanceId }) => {
        if (!useUpdateChat) {
            return;
        }
        let { fieldName, initialValue, finalValue } = event;
        const fieldConfig = form.getFieldConfigByFieldPath(fieldName);
        if (isEmptyDeep(finalValue) || equals(initialValue, finalValue)) {
            return;
        }
        const formattedValue = formatInferredValue(finalValue, fieldConfig);
        const str = `<strong>${fieldConfig.label || fieldConfig.key}</strong>: ${formattedValue}`;
        //getFormInstance(instanceId).chatbotService.addMessage({ role: "assistant", messageType: "answer", text: str });
        getFormInstance(instanceId).chatbotService.dispatch("appendMessage", { text: str, role: "assistant" });
    });
}
export function useFieldAutoFocus(elementRef, fieldPath, autoFocus) {
    const fluidForm = useFluidForm();
    useEffect(() => {
        if (elementRef.current && fluidForm.currentField === fieldPath) {
            // Disabling this temporarly to asses 
            // if (autoFocus !== false) {
            //   elementRef.current.focus();
            // }
            scrollIntoView(elementRef.current, { behavior: "smooth", block: "center", inline: "nearest", boundary: document.getElementsByClassName("fluid-form-container")[0] });
        }
    }, [fluidForm.currentField]);
}
